// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: Object.freeze(['table-cell', 'border-b', 'align-middle', 'px-2', 'text-carbon-50']),
});
